export default "__VITE_ASSET__26b77eef__"